/**
 * Created on 2017-06-28.
 */

// node_modules
let crypto = require("crypto");

// modules
let encryption = require("./encryption");

// properties
const VERSION = '1.0.0';
const NAME = 'crypto-utils';

// methods


/**
 * generates random string of characters i.e salt
 * @function
 * @param {number} length - Length of the random string.
 */
let genRandomString = function (length) {
    return crypto.randomBytes(Math.ceil(length / 2))
        .toString('hex') // convert to hexadecimal format
        .slice(0, length);
    /** return required number of characters */
};

/**
 * hash password with sha512.
 * @function
 * @param {string} text - List of required fields.
 * @param {string} salt - Data to be validated.
 */
let sha512 = function (text, salt) {
    let hash = crypto.createHmac('sha512', salt); // Hashing algorithm sha512
    hash.update(text);
    let value = hash.digest('hex');
    return {
        salt: salt,
        hash: value
    };
};

let sha256 = function (text, salt) {
    let hash = crypto.createHmac('sha256', salt); // Hashing algorithm sha512
    hash.update(text);
    let value = hash.digest('hex');
    return {
        salt: salt,
        hash: value
    };
};

function saltHashPassword(userpassword) {
    let salt = genRandomString(16); // Gives us salt of length 16
    salt = module.exports.randomString(32);
    let passwordData = sha512(userpassword, salt);
    // let passwordData = sha256(userpassword, salt);
    // console.log('UserPassword = ' + userpassword);
    // console.log('Passwordhash = ' + passwordData.hash);
    // console.log('nSalt = ' + passwordData.salt);
}

// saltHashPassword('MYPASSWORD');
// saltHashPassword('MYPASSWORD');
//
// console.log(module.exports.randomString(32));

// export

module.exports = {
    VERSION: VERSION,
    NAME: NAME,

    randomString: function(length, outputType) {
        outputType = outputType || 'base64';
        return crypto.randomBytes(Math.ceil(length * 3 / 4))
            .toString(outputType)   // convert to base64 format
            .slice(0, length)        // return required number of characters
            .replace(/\+/g, '0')  // replace '+' with '0'
            .replace(/\//g, '0'); // replace '/' with '0'
    },

    randomHexString: function (size) {
        if (size === 0) {
            throw new Error('Zero-length randomHexString is useless.');
        }
        if (size % 2 !== 0) {
            throw new Error('randomHexString size must be divisible by 2.');
        }
        return (0, crypto.randomBytes)(size / 2).toString('hex');
    },

    newObjectId: function (useCrypto = true) {
        if (useCrypto !== false) {
            return this.randomStringFast(10);
        }
        return this.randomString(10);
    },

    // Returns a new random hex string suitable for secure tokens.
    newToken: function () {
        return this.randomHexString(32);
    },

    md5Hash: function (string) {
        return (0, crypto.createHash)('md5').update(string).digest('hex');
    },

    sha512: sha512,
    sha256: sha256,

    identificationData: function(items, salt) {
        items = items || [];
        if (typeof items === 'string') {
            items = [items];
        }

        salt = salt || this.newObjectId();

        let text = items.join(', ');

        return this.sha512(text, salt);
    },

    encryption: encryption,

    /**
     * Returns the current time without milliseconds
     * @return {number}
     */
    secureDateTime: () => {
        return parseInt(new Date().getTime() * 0.001, 10);
    },

    /**
     * This method returns uppercase readable string
     * by generating a random string
     * without using characters that can be confused like O0 or B8, or 1l, CG, EF
     * @param length
     * @returns {string}
     */
    randomStupidString: (length) => {
        let result = '';
        let characters = 'ADFGHJKLMNPRSTWXYZ2345679';
        let charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    },

    /**
     * Return random string without using crypto
     * @param length
     * @returns {string}
     */
    randomStringFast: (length) => {
        let result = '';
        let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    },

    /**
     * Simple implementation of Java hashCode
     * @param string
     * @param makePositive
     * @returns {number}
     */
    hashCode: (string, makePositive = false) => {
        let hash = 0;
        if (string.length === 0) {
            return hash;
        }
        for (let i = 0; i < string.length; i++) {
            let char = string.charCodeAt(i);
            hash = ((hash<<5)-hash)+char;
            hash = hash & hash; // Convert to 32bit integer
        }

        if (makePositive === true) {
            // hash += -1266723936 * -1 + 9999999999; // '9999999999' should be 9999999999
            hash += -2054162789 * -1 + 1234567890; // '1234567890' should be 1234567890
        }

        return hash;
    },
};